import { render, staticRenderFns } from "./padeProc.vue?vue&type=template&id=63bf1100&"
import script from "./padeProc.vue?vue&type=script&lang=js&"
export * from "./padeProc.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports